module.exports = __webpack_public_path__ + "static/sunburst-78d9f15f223d640dcc8c21ffb15a8f4b.png";